import React from 'react'
import { Link } from 'react-static'

import brainSvg from '../assets/intento-brain.svg'
import HeroBase from './HeroBase'

import { trackedClick } from '../utils'

const HeroMain = () => (
    <HeroBase cols>
        <div className="hero__col hero__col--image">
            <div className="hero__image">
                <img src={brainSvg} alt="" className="animate-appear" />
            </div>
        </div>
        <div className="hero__col hero__col--content">
            <div className="hero__content">
                <h1 className="hero__title h1">
                    Discover,
                    <br />
                    evaluate and use
                    <br />
                    best-of-breed AI
                </h1>
                <p className="hero__text">
                    A&nbsp;simple and elegant API to&nbsp;third-party
                    AI&nbsp;models from many vendors.
                </p>
                <div className="hero__cta">
                    <Link
                        tabIndex="0"
                        onClick={trackedClick('Go to catalog clicked', {
                            source: 'Main page',
                            title: 'Next to brain',
                        })}
                        className="hero__cta-button button button--lg button--white button--text-blue button--shadow"
                        to="/api-platform"
                        href="/api-platform"
                        title="Try it"
                    >
                        Try it
                    </Link>
                </div>
            </div>
        </div>
    </HeroBase>
)

export default HeroMain



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/HeroMain.jsx